module.exports={
  "name": "Kiribati",
  "altSpellings": [
    "KI",
    "Republic of Kiribati",
    "Ribaberiki Kiribati"
  ],
  "area": 811,
  "borders": [],
  "callingCodes": [
    "686"
  ],
  "capital": "South Tarawa",
  "currencies": [
    "AUD"
  ],
  "demonym": "I-Kiribati",
  "flag": "",
  "geoJSON": {},
  "ISO": {
    "alpha2": "KI",
    "alpha3": "KIR"
  },
  "languages": [
    "en"
  ],
  "latlng": [
    1.41666666,
    173
  ],
  "nativeName": "Kiribati",
  "population": 106461,
  "provinces": [
    "Abaiang",
    "Abemama",
    "Aranuka",
    "Arorae",
    "Banaba",
    "Beru",
    "Butaritari",
    "Central Gilberts",
    "Gilbert Islands",
    "Kanton",
    "Kiritimati",
    "Kuria",
    "Line Islands",
    "Line Islands",
    "Maiana",
    "Makin",
    "Marakei",
    "Nikunau",
    "Nonouti",
    "Northern Gilberts",
    "Onotoa",
    "Phoenix Islands",
    "Southern Gilberts",
    "Tabiteuea",
    "Tabuaeran",
    "Tamana",
    "Tarawa",
    "Tarawa",
    "Teraina"
  ],
  "region": "Oceania",
  "subregion": "Micronesia",
  "timezones": [
    "UTC+12:00",
    "UTC+13:00",
    "UTC+14:00"
  ],
  "tld": [
    ".ki"
  ],
  "translations": {
    "de": "Kiribati",
    "es": "Kiribati",
    "fr": "Kiribati",
    "ja": "キリバス",
    "it": "Kiribati"
  },
  "wiki": "http://en.wikipedia.org/wiki/kiribati"
}
